import React, {useState} from "react";
import {withRouter} from "react-router-dom";
import {Collapse, Divider, Drawer, List, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {
    Business as AccountIcon,
    ExpandLess,
    ExpandMore,
    Fingerprint as PasswordIcon,
    Info as AboutIcon,
    Logout as LogoutIcon,
    People as UsersIcon,
    Settings as SettingsIcon,
    SwapHoriz as SwitchIcon,
} from "@mui/icons-material";
import {AccountAvatar} from "@atttomyx/react-components";
import * as authService from "../../services/auth";
import {confirm, mobile, router} from "@atttomyx/react-utils";
import {sorting} from "@atttomyx/shared-utils";
import {
    PAGE_ABOUT,
    PAGE_JOIN_ACCOUNT,
    PAGE_ACCOUNT,
    PAGE_PASSWORD,
    PAGE_PROFILE, PAGE_USERS,
} from "../../constants";
import "./moreMenu.css";

const MoreMenu = (props) => {
    const {snackbar, history, bootstrap, onCancel, onLogout, onSwitchAccounts} = props;
    const [showAccounts, setShowAccounts] = useState(false);

    const account = bootstrap ? bootstrap.account : null;
    const user = bootstrap ? bootstrap.user : null;
    const accounts = bootstrap ? bootstrap.accounts : [];

    const closeAndRedirect = (page) => {
        onCancel();
        router.redirectTo(history, page);
    };

    const closeAndSwitchAccounts = (accountId) => {
        onCancel();
        const switchAccountFailure = (err) => {
            if (snackbar && snackbar.setError) {
                snackbar.setError(err);
            } else {
                console.error(err);
            }
        };
        authService.switchAccounts(accountId, onSwitchAccounts, switchAccountFailure);
    };

    const renderLogo = (acc) => {
        const branding = acc.branding || {};

        return <>
            <ListItemIcon>
                <AccountAvatar account={acc} size="small" mode="no-title"/>
            </ListItemIcon>
            {!branding.logoContainsName ?
                <ListItemText>{acc.name}</ListItemText> : null}
        </>
    };

    const renderAccounts = () => {
        if (!bootstrap) return null;

        return <>
            <ListItemButton onClick={() => setShowAccounts(!showAccounts)}>
                <ListItemIcon><SwitchIcon/></ListItemIcon>
                <ListItemText>Switch</ListItemText>
                {showAccounts ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={showAccounts} timeout="auto" unmountOnExit>
                <List disablePadding className="sub-menu">
                    {accounts.sort(sorting.sortByName).filter(candidate => candidate.id !== account.id).map(acc =>
                        <ListItemButton
                            key={acc.id}
                            onClick={() => closeAndSwitchAccounts(acc.id)}
                        >
                            {renderLogo(acc)}
                        </ListItemButton>)}
                    {user ? (
                        <ListItemButton onClick={() => closeAndRedirect(PAGE_JOIN_ACCOUNT)}>
                            <ListItemText>Join account...</ListItemText>
                        </ListItemButton>
                    ) : null}
                </List>
            </Collapse>
        </>
    };

    return <Drawer
        anchor="right"
        className="more-menu"
        open={true}
        onClose={onCancel}
    >
        <List>
            {user && user.roles.admin ? <>
                    <ListItemButton onClick={() => closeAndRedirect(PAGE_ACCOUNT)}>
                        <ListItemIcon><AccountIcon/></ListItemIcon>
                        <ListItemText>Account</ListItemText>
                    </ListItemButton>
                    <ListItemButton onClick={() => closeAndRedirect(PAGE_USERS)}>
                        <ListItemIcon><UsersIcon/></ListItemIcon>
                        <ListItemText>Users</ListItemText>
                    </ListItemButton>
                    <Divider/>
                </> : null}
            <ListItemButton onClick={() => closeAndRedirect(PAGE_PROFILE)}>
                <ListItemIcon><SettingsIcon/></ListItemIcon>
                <ListItemText>Settings</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_PASSWORD)}>
                <ListItemIcon><PasswordIcon/></ListItemIcon>
                <ListItemText>Password</ListItemText>
            </ListItemButton>
            <ListItemButton onClick={() => confirm.confirm(mobile.isMobile()
                ? "Someone would need to have physical access to your phone to access this account. Are you sure you want to logout?"
                : "Are you sure you want to logout?", onLogout)}>
                <ListItemIcon><LogoutIcon/></ListItemIcon>
                <ListItemText>Logout</ListItemText>
            </ListItemButton>
            {renderAccounts()}
            <Divider/>
            <ListItemButton onClick={() => closeAndRedirect(PAGE_ABOUT)}>
                <ListItemIcon><AboutIcon/></ListItemIcon>
                <ListItemText>About</ListItemText>
            </ListItemButton>
        </List>
    </Drawer>
};

export default withRouter(MoreMenu);
